import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var mainStaticPageSchema = {
    bg_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на български*',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име',
    }),
    en_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на английски*',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име',
    }),
    page_type: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            options: [],
        }),
        elementType: 'dropdown',
        label: 'Тип страница*',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валиден статус',
    }),
    slug: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Slug *',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден slug',
    }),
    // bg_description: new FormItem({
    //     elementConfig: new ElementConfig({
    //         className: 'editor',
    //     }),
    //     elementType: 'editor',
    //     label: 'Описание на български *',
    //     value: null,
    //     validation: {
    //         required: true
    //     },
    //     valid: false,
    //     touched: false,
    //     errorMsg: 'Моля, въвдете валидно описание на български',
    // }),
    bg_description_json: new FormItem({
        elementConfig: new ElementConfig({
            className: 'btn btn-primary',
        }),
        elementType: 'buttonModal',
        label: 'Описание на български *',
        value: null,
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно описание на български',
    }),
    // en_description: new FormItem({
    //     elementConfig: new ElementConfig({
    //         className: 'editor',
    //     }),
    //     elementType: 'editor',
    //     label: 'Описание на английски *',
    //     value: null,
    //     validation: {
    //         required: true
    //     },
    //     valid: false,
    //     touched: false,
    //     errorMsg: 'Моля, въвдете валидно описание на английски',
    // }),
    en_description_json: new FormItem({
        elementConfig: new ElementConfig({
            className: 'btn btn-primary',
        }),
        elementType: 'buttonModal',
        label: 'Описание на английски *',
        value: null,
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно описание на английски',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
    canonical_url: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Canonical URL',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въвдете валиден Canonical url',
    }),
};
export default mainStaticPageSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/mainStaticPageSchema.ts
// module id = 366
// module chunks = 0